import { TextArea } from "@bluframe/blublocks"
import {
  FieldLabel,
  FieldLabelAndValue,
  FieldRow,
  FieldValue
} from "components/Fields/styled"

import { ComponentProps } from "."

const BioRow = ({
  bioRef,
  isEditMode,
  item
}: Pick<ComponentProps, "bioRef" | "isEditMode" | "item">) => (
  <FieldRow $items={1}>
    {isEditMode ? (
      <TextArea
        defaultValue={item?.bio || ""}
        inputId="bio"
        label="Bio"
        name="bio"
        ref={bioRef}
      />
    ) : (
      <FieldLabelAndValue>
        <FieldLabel>{"Bio"}</FieldLabel>

        <FieldValue>{item?.bio}</FieldValue>
      </FieldLabelAndValue>
    )}
  </FieldRow>
)

export default BioRow
